(function () {
  'use strict';

  var cfg = window.LMP_APP_CONFIG || {};
  var isStandalone = !!cfg.standalone ||
    (window.matchMedia && window.matchMedia('(display-mode: standalone)').matches) ||
    window.navigator.standalone === true;
  var mobile = window.matchMedia ? window.matchMedia('(max-width: 989px)').matches : window.innerWidth < 990;
  var installPrompt = null;
  var installDelayElapsed = false;
  var installTimerStarted = false;
  var INSTALL_DELAY_MS = 15000;

  function icon(name) {
    var icons = {
      home: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" aria-hidden="true"><path d="M3 10.8 12 3l9 7.8"/><path d="M5.5 9.8V21h13V9.8"/><path d="M9.5 21v-6h5v6"/></svg>',
      grid: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" aria-hidden="true"><rect x="3" y="3" width="7" height="7" rx="2"/><rect x="14" y="3" width="7" height="7" rx="2"/><rect x="3" y="14" width="7" height="7" rx="2"/><rect x="14" y="14" width="7" height="7" rx="2"/></svg>',
      search: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="m20 20-4-4"/></svg>',
      user: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" aria-hidden="true"><circle cx="12" cy="8" r="4"/><path d="M4.5 21c.8-4 3.3-6 7.5-6s6.7 2 7.5 6"/></svg>',
      cart: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" aria-hidden="true"><path d="M3 4h2l2.2 10.2a2 2 0 0 0 2 1.6h7.9a2 2 0 0 0 1.9-1.4L21 8H7"/><circle cx="10" cy="20" r="1"/><circle cx="18" cy="20" r="1"/></svg>'
    };
    return icons[name] || '';
  }

  function currentFor(url, key) {
    if (key === 'home') return location.pathname === '/';
    if (key === 'search') return location.pathname.indexOf('/search') === 0;
    if (key === 'cart') return location.pathname.indexOf('/cart') === 0;
    if (key === 'account') return location.pathname.indexOf('/account') === 0;
    if (key === 'categories') return location.pathname.indexOf('/pages/categories-parapharmacie') === 0 || location.pathname.indexOf('/collections') === 0;
    return false;
  }

  function navItem(url, label, ico, key, extra) {
    var a = document.createElement('a');
    a.className = 'lmp-app-nav__item';
    a.href = url;
    a.setAttribute('aria-label', label);
    if (currentFor(url, key)) a.setAttribute('aria-current', 'page');
    a.innerHTML = icon(ico) + '<span>' + label + '</span>' + (extra || '');
    return a;
  }

  function buildNav() {
    if (!isStandalone || !mobile || document.querySelector('.lmp-app-nav')) return;
    var nav = document.createElement('nav');
    nav.className = 'lmp-app-nav';
    nav.setAttribute('aria-label', 'Navigation de l’application');
    nav.appendChild(navItem(cfg.homeUrl || '/', 'Accueil', 'home', 'home'));
    nav.appendChild(navItem(cfg.categoriesUrl || '/pages/categories-parapharmacie', 'Catégories', 'grid', 'categories'));
    nav.appendChild(navItem(cfg.searchUrl || '/search', 'Recherche', 'search', 'search'));
    nav.appendChild(navItem(cfg.accountUrl || '/account', 'Compte', 'user', 'account'));
    nav.appendChild(navItem(cfg.cartUrl || '/cart', 'Panier', 'cart', 'cart', '<span class="lmp-app-nav__badge" data-lmp-cart-count hidden></span>'));
    document.body.appendChild(nav);
    refreshCartCount();
  }

  function refreshCartCount() {
    var badge = document.querySelector('[data-lmp-cart-count]');
    if (!badge || !window.fetch) return;
    fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (cart) {
        if (!cart) return;
        var count = Number(cart.item_count || 0);
        if (count > 0) {
          badge.textContent = count > 99 ? '99+' : String(count);
          badge.hidden = false;
        } else {
          badge.hidden = true;
        }
      })
      .catch(function () {});
  }

  function dismissInstall() {
    var el = document.querySelector('.lmp-app-install');
    if (el) el.remove();
    try { localStorage.setItem('lmp-install-dismissed', String(Date.now())); } catch (e) {}
  }

  function recentlyDismissed() {
    try {
      var t = Number(localStorage.getItem('lmp-install-dismissed') || 0);
      return t && (Date.now() - t) < 7 * 24 * 60 * 60 * 1000;
    } catch (e) { return false; }
  }

  function buildInstallCard(mode) {
    if (isStandalone || !mobile || recentlyDismissed() || document.querySelector('.lmp-app-install')) return;
    var card = document.createElement('aside');
    card.className = 'lmp-app-install';
    card.setAttribute('role', 'dialog');
    card.setAttribute('aria-label', 'Installer La Maison Para');
    var text = mode === 'ios' ? 'Ajoutez La Maison Para à votre écran d’accueil.' : 'Accédez plus vite à vos produits et promotions.';
    var button = mode === 'ios' ? 'Comment ?' : 'Installer';
    card.innerHTML =
      '<img class="lmp-app-install__logo" src="' + (cfg.logoUrl || '/favicon.ico') + '" alt="">' +
      '<div class="lmp-app-install__copy"><p class="lmp-app-install__title">La Maison Para</p><p class="lmp-app-install__text">' + text + '</p></div>' +
      '<button class="lmp-app-install__button" type="button">' + button + '</button>' +
      '<button class="lmp-app-install__close" type="button" aria-label="Fermer">×</button>';
    card.querySelector('.lmp-app-install__close').addEventListener('click', dismissInstall);
    card.querySelector('.lmp-app-install__button').addEventListener('click', function () {
      if (mode === 'ios') {
        showIosHelp();
        card.remove();
        return;
      }
      if (!installPrompt) return;
      installPrompt.prompt();
      installPrompt.userChoice.then(function () {
        installPrompt = null;
        card.remove();
      }).catch(function () {});
    });
    document.body.appendChild(card);
    requestAnimationFrame(function () { card.classList.add('is-visible'); });
  }

  function showIosHelp() {
    if (document.querySelector('.lmp-ios-help')) return;
    var box = document.createElement('div');
    box.className = 'lmp-ios-help';
    box.setAttribute('role', 'dialog');
    box.innerHTML = '<h3>Installer La Maison Para</h3><p>Dans Safari, touchez <strong>Partager</strong>, puis <strong>Ajouter à l’écran d’accueil</strong> et confirmez.</p><button type="button" aria-label="Fermer">×</button>';
    box.querySelector('button').addEventListener('click', function () { box.remove(); });
    document.body.appendChild(box);
  }

  function isIosSafari() {
    var ua = navigator.userAgent || '';
    var ios = /iPhone|iPad|iPod/i.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
    var webkit = /WebKit/i.test(ua);
    var other = /CriOS|FxiOS|EdgiOS|OPiOS/i.test(ua);
    return ios && webkit && !other;
  }

  function revealInstallOffer() {
    installDelayElapsed = true;
    if (installPrompt) {
      buildInstallCard('native');
    } else if (isIosSafari()) {
      buildInstallCard('ios');
    }
  }

  function scheduleInstallOffer() {
    if (installTimerStarted || isStandalone || !mobile) return;
    installTimerStarted = true;
    window.setTimeout(revealInstallOffer, INSTALL_DELAY_MS);
  }

  window.addEventListener('beforeinstallprompt', function (event) {
    event.preventDefault();
    installPrompt = event;
    if (installDelayElapsed) buildInstallCard('native');
  });

  window.addEventListener('appinstalled', function () {
    var card = document.querySelector('.lmp-app-install');
    if (card) card.remove();
    try { localStorage.removeItem('lmp-install-dismissed'); } catch (e) {}
  });

  function finishSplash() {
    if (!document.documentElement.classList.contains('lmp-booting')) return;
    var start = Number(window.__LMP_BOOT_AT || 0);
    var now = (window.performance && performance.now) ? performance.now() : Date.now();
    var remaining = Math.max(0, 650 - (now - start));
    window.setTimeout(function () {
      document.documentElement.classList.remove('lmp-booting');
    }, remaining);
  }

  function init() {
    buildNav();
    finishSplash();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  if (document.readyState === 'complete') {
    scheduleInstallOffer();
  } else {
    window.addEventListener('load', scheduleInstallOffer, { once: true });
  }
  window.addEventListener('load', finishSplash, { once: true });
}());
